export default {
    computed: {
        breakpoints() {
            return {
                xs:0,
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200
            }
        }
    }
}